import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import UIBody from "../../../components/ui/UIBody";

// Utility to strip HTML tags
const stripHTML = (html) => {
  return html ? html.replace(/<[^>]+>/g, "") : "";
};

export default function LatestBlogs() {
  const [responce, loading, error, callAPI] = useApiCallHooks();

  useEffect(() => {
    callAPI("get", "get-blogs");
  }, []);

  return (
    <UIBody
      loading={loading}
      content={
        <section className="py-5 bg-light">
          <div className="container">
            {/* Section Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold">Latest Blogs</h2>
              <p className="text-muted">
                Stay updated with our latest articles, insights, and resources.
              </p>
            </div>

            <div className="row">
              {responce?.data && responce.data.length > 0 ? (
                responce.data.map((blog) => (
                  <div className="col-md-4 mb-4" key={blog.id}>
                    <Link
                      to={`/blogs/${blog.slug}`}
                      className="text-decoration-none"
                    >
                      <div
                        className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden"
                        style={{
                          transition: "all 0.3s ease",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-8px)";
                          e.currentTarget.style.boxShadow =
                            "0 12px 24px rgba(0,0,0,0.15)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(0,0,0,0.1)";
                        }}
                      >
                        {/* Blog Image */}
                        <div className="position-relative overflow-hidden">
                          <img
                            src={blog.image}
                            alt={blog.name}
                            className="w-100"
                            style={{
                              height: "240px",
                              objectFit: "cover",
                              transition: "transform 0.4s ease",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.transform = "scale(1.08)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          />
                          {blog.category && (
                            <span
                              className="badge bg-primary position-absolute"
                              style={{ top: "15px", left: "15px" }}
                            >
                              {blog.category}
                            </span>
                          )}
                        </div>

                        {/* Card Body */}
                        <div className="card-body d-flex flex-column">
                          <h5
                            className="fw-bold mb-2"
                            style={{ transition: "color 0.3s ease" }}
                          >
                            {blog.name}
                          </h5>
                          <p className="text-muted flex-grow-1">
                            {stripHTML(blog.description).length > 100
                              ? stripHTML(blog.description).substring(0, 100) +
                                "..."
                              : stripHTML(blog.description)}
                          </p>
                          <div className="mt-3">
                            <span className="text-primary fw-semibold">
                              Read More →
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
              ) : (
                !loading && (
                  <p className="text-center text-muted">No blogs found.</p>
                )
              )}
            </div>
          </div>
        </section>
      }
    />
  );
}
